import { i18n } from '/business/shared/translations/i18n';

// TODO - this is now partially in the api
export const dailyDistancesLookup = () => {
  return {
    miles: [
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.mile.low', '<12.5 miles'),
        name: 'low',
        unit: 'km',
        value: 20,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.mile.medium', '12.5-31 miles'),
        name: 'medium',
        unit: 'km',
        value: 50,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.mile.high', '>31 miles'),
        name: 'high',
        unit: 'km',
        value: 100,
      },
    ],
    km: [
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.km.low', '<20 km'),
        name: 'low',
        unit: 'km',
        value: 20,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.km.medium', '20-50 km'),
        name: 'medium',
        unit: 'km',
        value: 50,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesDaily.km.high', '>50 km'),
        name: 'high',
        unit: 'km',
        value: 100,
      },
    ],
  };
};
export const annualDistancesLookup = (usesHighMileageDistances = false) => {
  if (usesHighMileageDistances) {
    return {
      miles: [
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.mile.low', '< 18,750 miles'),
          name: 'low',
          unit: 'km',
          value: 30000,
        },
        {
          displayName: i18n.t(
            'business:emissionFactors.distanceRangesAnnualBusCoach.mile.medium',
            '18,750 - 43,750 miles',
          ),
          name: 'medium',
          unit: 'km',
          value: 70000,
        },
        {
          displayName: i18n.t(
            'business:emissionFactors.distanceRangesAnnualBusCoach.mile.high',
            '43,750 - 93,750 miles',
          ),
          name: 'high',
          unit: 'km',
          value: 150000,
        },
        {
          displayName: i18n.t(
            'business:emissionFactors.distanceRangesAnnualBusCoach.mile.higher',
            '93,750 - 156,250 miles',
          ),
          name: 'higher',
          unit: 'km',
          value: 250000,
        },
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.mile.highest', '> 156,250 miles'),
          name: 'highest',
          unit: 'km',
          value: 300000,
        },
      ],
      km: [
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.km.low', '< 30,000 km'),
          name: 'low',
          unit: 'km',
          value: 30000,
        },
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.km.medium', '30,000 - 70,000 km'),
          name: 'medium',
          unit: 'km',
          value: 70000,
        },
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.km.high', '70,000 - 150,000 km'),
          name: 'high',
          unit: 'km',
          value: 150000,
        },
        {
          displayName: i18n.t(
            'business:emissionFactors.distanceRangesAnnualBusCoach.km.higher',
            '150,000 - 250,000 km',
          ),
          name: 'higher',
          unit: 'km',
          value: 250000,
        },
        {
          displayName: i18n.t('business:emissionFactors.distanceRangesAnnualBusCoach.km.highest', '> 250,000 km'),
          name: 'highest',
          unit: 'km',
          value: 300000,
        },
      ],
    };
  }
  return {
    miles: [
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.mile.low', '<12,500 miles'),
        name: 'low',
        unit: 'km',
        value: 20000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.mile.medium', '12,500-31,000 miles'),
        name: 'medium',
        unit: 'km',
        value: 50000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.mile.high', '31,000-62,000 miles'),
        name: 'high',
        unit: 'km',
        value: 100000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.mile.higher', '62,000 - 93,000 miles'),
        name: 'higher',
        unit: 'km',
        value: 150000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.mile.highest', '>93,000 miles'),
        name: 'highest',
        unit: 'km',
        value: 300000,
      },
    ],
    km: [
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.km.low', '<20,000 km'),
        name: 'low',
        unit: 'km',
        value: 20000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.km.medium', '20,000-50,000 km'),
        name: 'medium',
        unit: 'km',
        value: 50000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.km.high', '50,000-100,000 km'),
        name: 'high',
        unit: 'km',
        value: 100000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.km.higher', '100,000-150,000 km'),
        name: 'higher',
        unit: 'km',
        value: 150000,
      },
      {
        displayName: i18n.t('business:emissionFactors.distanceRangesAnnual.km.highest', '>150,000 km'),
        name: 'highest',
        unit: 'km',
        value: 300000,
      },
    ],
  };
};
